<p-toast></p-toast>

<div class="card">
    <h2>Registro del Distribuidor</h2>

    <form [formGroup]="formDistribuidor" (ngSubmit)="onSubmit()">

        <!-- 🧍 Datos generales del usuario -->
        <div class="p-fluid grid">

            <div class="col-12 md:col-6">
                <label>Nombre</label>
                <input pInputText type="text"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    formControlName="nombre"
                    [ngClass]="{'ng-invalid ng-dirty': f['nombre'].touched && f['nombre'].errors}" />
                <small class="p-error" *ngIf="f['nombre'].touched && f['nombre'].errors?.['required']">
                    El nombre es requerido
                </small>
            </div>

            <div class="col-12 md:col-6">
                <label>Primer Apellido</label>
                <input pInputText type="text"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    formControlName="primerApellido"
                    [ngClass]="{'ng-invalid ng-dirty': f['primerApellido'].touched && f['primerApellido'].errors}" />
                <small class="p-error" *ngIf="f['primerApellido'].touched && f['primerApellido'].errors?.['required']">
                    El Apellido Paterno es requerido
                </small>
            </div>

            <div class="col-12 md:col-6">
                <label>Segundo Apellido</label>
                <input pInputText type="text"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    formControlName="segundoApellido" />
            </div>

            <div class="col-12 md:col-6">
                <label>Teléfono Móvil</label>
                <input pInputText type="text" maxlength="10"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    formControlName="telefonoMovil" />
            </div>

            <div class="col-12 md:col-6">
                <label>Correo </label>
                <input pInputText type="text" maxlength="100"
                    class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
                    formControlName="correo" />
                <small class="p-error" *ngIf="f['correo'].touched && f['correo'].errors?.['required']">
                    El correo es requerido
                </small>
                <small class="p-error" *ngIf="f['correo'].touched && f['correo'].errors?.['email']">
                    El correo es invalido
                </small>
            </div>

        </div>

        <div class="field col-12 md:col-4">
            <p-button type="button" label="Cancelar" (click)="cancelar()" styleClass="p-button-sm mr-3"></p-button>
            <!-- 
                <p-button type="submit" label="Guardar" icon="pi pi-save" [disabled]="formDistribuidor.invalid">
                </p-button>
            
            -->
        </div>

    </form>

</div>